import getColor from '~/lib/getColor'

export const BORDER = `1px solid ${getColor('blackAlpha15')}`

// TODO:: we have several places make these constants, will consolidate them later
export const DOMESTIC = 'domestic'
export const OVERSEAS = 'overseas'

export const GENERIC_DISABLED_OPTION_TOOLTIP_TITLE =
    'This shipping option is not available for one or more parts in your quote. Switch to selecting lead times individually to view possible mixed production options.'
export const DISABLED_OPTION_TOOLTIP_TITLE_RFQ =
    'Your quote and lead time selection have been requested. If you need to make changes, click “edit quote” and re-request once updated.'
export const DISABLED_OPTION_TOOLTIP_TITLE_REORDER =
    'Your quote price is based on the configuration from a previous order. Unlocking the quote to make changes may affect pricing.'

const FASTEST = 'Fastest'
const STANDARD = 'Standard'
const COST_EFFECTIVE = 'Cost-effective'

const DOMESTIC_FASTEST = 'domesticFastest'
const DOMESTIC_STANDARD = 'domesticStandard'
const DOMESTIC_COST_EFFECTIVE = 'domesticCostEffective'
const OVERSEAS_FASTEST = 'overseasFastest'
const OVERSEAS_STANDARD = 'overseasStandard'
const OVERSEAS_COST_EFFECTIVE = 'overseasCostEffective'

export const OPTIONS_DESCRIPTION_MAPPING: { [key: string]: string } = {
    [DOMESTIC_FASTEST]: FASTEST,
    [DOMESTIC_STANDARD]: STANDARD,
    [DOMESTIC_COST_EFFECTIVE]: COST_EFFECTIVE,
    [OVERSEAS_FASTEST]: FASTEST,
    [OVERSEAS_STANDARD]: STANDARD,
    [OVERSEAS_COST_EFFECTIVE]: COST_EFFECTIVE,
}

export const QUOTE_LEVEL_LEAD_TIME_OPTIONS_ORDER: { [key: string]: number } = {
    [DOMESTIC_FASTEST]: 1,
    [DOMESTIC_STANDARD]: 2,
    [DOMESTIC_COST_EFFECTIVE]: 3,
    [OVERSEAS_FASTEST]: 4,
    [OVERSEAS_STANDARD]: 5,
    [OVERSEAS_COST_EFFECTIVE]: 6,
}

export const HIDE_QUOTE_LEVEL_LEAD_TIME_CONFIRMATION_MODAL =
    '__hide_quote_level_lead_time_confirmation_modal'

export const CONFIGURE_QLLT = 'configure-qllt'
export const CONFIGURE_MANUAL = 'configure-manual'

export type OptionType = typeof CONFIGURE_QLLT | typeof CONFIGURE_MANUAL

export const HOLIDAY_HELP_ARTICLE_LINK =
    'https://www.fictiv.com/articles/supply-chain-update-december-2021-and-chinese-new-year'

export const CHINESE_NEW_YEAR_HOLIDAY_NAME = 'Chinese New Year'
